import type { DesktopFeatureConfig } from '../desktop';

export type DesktopFeaturesFreemium = {
  duration: DesktopFeatureConfig;
  listing: DesktopFeatureConfig;
  connections: DesktopFeatureConfig;
  photo: DesktopFeatureConfig;
  searchRank: DesktopFeatureConfig;
  boostedEmail: DesktopFeatureConfig;
  featuredSearch: DesktopFeatureConfig;
  featuredEmail: DesktopFeatureConfig;
};

export const desktopFeatureLabelsFreemium: Record<
  keyof DesktopFeaturesFreemium,
  string
> = {
  duration: 'Listing duration',
  listing: "Appear on Australia's #1 business marketplace",
  connections: 'Receive emails from interested buyers',
  photo: 'Photo included in search results',
  searchRank: 'Appear higher in search results',
  boostedEmail: 'Include in daily buyer recommendation emails',
  featuredEmail: 'Feature at the top of search results',
  featuredSearch: 'Priority placement in daily buyer recommendation emails',
};

export const desktopRenderOrderFreemium: Array<keyof DesktopFeaturesFreemium> =
  [
    'duration',
    'listing',
    'connections',
    'photo',
    'searchRank',
    'boostedEmail',
    'featuredEmail',
    'featuredSearch',
  ];
